import { api } from "./client";
import type { ActiveBuff, InventoryItem } from "../types";

export interface UseStashItemResult {
  active_buffs: ActiveBuff[];
  message?: string | null;
}

export const stashApi = {
  getItems: () => api.get<InventoryItem[]>("/stash"),
  use: (itemId: string, quantity = 1) =>
    api.post<UseStashItemResult>("/stash/use", { item_id: itemId, quantity }),
};
